import {
  AccountInfo,
  IPublicClientApplication,
  SilentRequest,
} from "@azure/msal-browser";
import store from "../../App/store/store";
import {
  HeiUser,
  selectHeiUser,
  selectToken,
  setHeiUser,
  setToken,
  logout,
} from "../store/accountSlice";
import axios from "axios";

const registerSession = async () => {
  await axios.get(`${window.configuration.apiUrl}api/Users/session`);
};

export const getTokenAndStore = async (
  publicClient: IPublicClientApplication,
  account: AccountInfo,
  forceRefresh?: boolean
) => {
  const token = selectToken(store.getState());
  if (token && !forceRefresh) {
    return token;
  }

  try {
    const clientId = window.configuration.apiClientId;

    const request: SilentRequest = {
      scopes: [`api://${clientId}/User.Read`],
      forceRefresh: forceRefresh || false,
      account: account,
    };

    const response = await publicClient?.acquireTokenSilent(request);

    const newToken = response?.accessToken;
    store.dispatch(setToken(newToken));

    const jwtPayload = getJwtPayload(newToken);

    const userName =
      [jwtPayload["given_name"], jwtPayload["family_name"]]
        .filter((p) => p)
        .join(" ") || jwtPayload["name"];

    // check if user is guest by looking for idp claim. If present, user is guest.
    const isGuest =
      jwtPayload["idp"] !== undefined && jwtPayload["idp"] !== null;

    const heiUser: HeiUser = {
      oid: jwtPayload["oid"] || "",
      adPrinciple: jwtPayload["upn"] || jwtPayload["unique_name"] || jwtPayload["email"] || "",
      name: userName,
      email: jwtPayload["email"] || jwtPayload["unique_name"],
      roles: jwtPayload["roles"] || [],
      initials: getFirstLetters(userName),
      isGuest: isGuest,
    };
    store.dispatch(setHeiUser(heiUser));

    // setTimeout(async () => {
    //   await registerSession();
    //   setInterval(async () => {
    //     await registerSession();
    //   }, 1000 * 60 * 5);
    // }, 5000);

    //   setTimeout(async () => {
    //     await getTokenAndStore(publicClient, account, true)
    //   }, 1000 * 60 * 15)

    return newToken;
  } catch (error) {
    console.error(error);

    // localStorage.clear();
    // sessionStorage.clear();
    // window.location.reload();

    return "";
  }
};

export const resolveLoggedUserFromBackend = async () => {
  const state = store.getState();
  const token = selectToken(state);
  const heiUser = selectHeiUser(state);

  if (!token || !heiUser.oid) {
    return;
  }

  try {
    const resolved = await axios.get<Partial<HeiUser>>(
      `${window.configuration.apiUrl}api/users/me/resolved`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (resolved.data) {
      store.dispatch(setHeiUser({ ...heiUser, ...resolved.data, oid: heiUser.oid }));
    }
  } catch {
    // keep claims-based user when resolved endpoint is unavailable
  }
};

export default function getJwtPayload(token: string) {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}

function getFirstLetters(str: string) {
  const words = str.split(" ");
  const result = [];

  for (const word of words) {
    result.push(word[0]);
  }
  return result.join("");
}

export const logoutUser = async (publicClient: IPublicClientApplication) => {
  try {
    store.dispatch(logout());

    localStorage.clear();
    sessionStorage.clear();

    // Logout from Azure AD
    await publicClient.logout();
  } catch (error) {
    console.error("Logout error:", error);
    // Fallback to redirect logout if popup fails
    await publicClient.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  }
};
